import LocalStorage from 'src/utils/LocalStorage'

export const SELECTED_GENDER_STORAGE_KEY = 'selected_gender'

export const ANY_GENDER_MENU_ID = '2'

export type GenderSources = {
  userGenderId?: string | number | null
  genderFromUrl?: string | null
  selectedGenderFromStorage?: string | null
  localSelection?: string | null
  formGenderId?: string | null
}

/** Valid profile `gender_id` (includes `0` = female — do not use truthy checks) */
export function hasUserProfileGender(
  userGenderId?: string | number | null,
): boolean {
  if (userGenderId === null || userGenderId === undefined) return false
  if (userGenderId === '') return false
  return true
}

export function getStoredSelectedGender(): string {
  return LocalStorage.getLocalStorage(SELECTED_GENDER_STORAGE_KEY) || ''
}

export function setStoredSelectedGender(gender: string | number): void {
  LocalStorage.setLocalStorage(SELECTED_GENDER_STORAGE_KEY, String(gender))
}

/** Priority: screen selection → form → URL → localStorage → user profile */
export function resolveEffectiveGender(sources: GenderSources): string {
  const {
    localSelection,
    formGenderId,
    genderFromUrl,
    selectedGenderFromStorage,
    userGenderId,
  } = sources

  if (localSelection) return String(localSelection)
  if (formGenderId) return String(formGenderId)
  if (genderFromUrl) return String(genderFromUrl)
  if (selectedGenderFromStorage) return String(selectedGenderFromStorage)
  if (hasUserProfileGender(userGenderId)) {
    return String(userGenderId)
  }

  return ''
}

export function hasEffectiveGender(sources: GenderSources): boolean {
  return Boolean(resolveEffectiveGender(sources))
}

export function needsGenderSelection(sources: GenderSources): boolean {
  return !hasEffectiveGender(sources)
}

/**
 * Whether to render the gender selection UI.
 * Based on "fixed" sources (profile / URL) only — NOT temporary on-screen selection —
 * so the picker stays visible after the user selects a value.
 */
export function shouldOfferGenderSelection(sources: GenderSources): boolean {
  return !hasUserProfileGender(sources.userGenderId) && !sources.genderFromUrl
}

export function isMenuGenderIncompatible(
  menuTargetGender: string | undefined,
  effectiveGender: string,
): boolean {
  if (!menuTargetGender || !effectiveGender) return false
  if (menuTargetGender === ANY_GENDER_MENU_ID) return false
  return menuTargetGender !== effectiveGender
}
